var _defs, _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChuzhen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    "data-name": "\\u56FE\\u5C42 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{opacity:0;}.cls-2,.cls-4,.cls-5{fill:red;}.cls-2{opacity:0.13;}.cls-3{fill:#ff6700;opacity:0.1;}.cls-4{opacity:0.09;}.cls-5{opacity:0.03;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "03_\u521D\u8BCA") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 3.96,
    y: 3.96,
    width: 56,
    height: 56
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 32.03,
    cy: 31.86,
    r: 28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 4.04,
    y: 7.86,
    width: 56,
    height: 48
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 8.04,
    y: 3.86,
    width: 48,
    height: 56
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.06,44.91,52,44.77V42.66A7.75,7.75,0,0,0,44.12,35H43.6a7.75,7.75,0,0,0-7.83,7.65v5.53a4.47,4.47,0,0,1-4.52,4.42h-.52a4.26,4.26,0,0,1-4.32-4.37V38.87h.12a2,2,0,0,0,2-2V36c3.89-.47,7-2.84,8.89-6.85a32.5,32.5,0,0,0,2-6.2c.43-1.78.71-3.26,1.23-6.32.14-.86.23-1.33.32-1.84.62-3.51.13-6.16-1.4-8A6.76,6.76,0,0,0,35,4.73l-2.88-.05A2.38,2.38,0,0,0,30.44,4a2.34,2.34,0,0,0-2.39,2.31,2.36,2.36,0,0,0,2.39,2.32,2.41,2.41,0,0,0,1.65-.65H35a2.72,2.72,0,0,1,1.75,1c.86,1.09,1.07,3,.63,5.43-.09.5-.16.94-.32,1.85-.45,2.67-.83,4.59-1.23,6.34a29.57,29.57,0,0,1-1.67,5.16c-1.34,2.94-3.13,4.63-5.59,5.08a2,2,0,0,0-2-1.94h-4a2,2,0,0,0-2,1.95c-2.49-.44-4.29-2.13-5.64-5.09a29.57,29.57,0,0,1-1.67-5.16c-.4-1.75-.78-3.67-1.23-6.34-.16-.91-.23-1.35-.32-1.85-.44-2.46-.23-4.34.63-5.43a2.72,2.72,0,0,1,1.75-1h2.87a2.41,2.41,0,0,0,1.65.65A2.36,2.36,0,0,0,21,6.27,2.34,2.34,0,0,0,18.58,4a2.38,2.38,0,0,0-1.72.72L14,4.73A6.76,6.76,0,0,0,9.44,6.84c-1.53,1.83-2,4.48-1.4,8,.09.51.18,1,.32,1.84.52,3.06.8,4.54,1.23,6.32a32.5,32.5,0,0,0,2,6.2c1.92,4,5,6.4,8.93,6.86v.82a2,2,0,0,0,2,2h.22v9.41a7.85,7.85,0,0,0,8,7.58h.52a7.76,7.76,0,0,0,7.83-7.66V42.66a4.48,4.48,0,0,1,4.52-4.43h.52a4.49,4.49,0,0,1,4.53,4.43v2.25a5.67,5.67,0,1,0,3.38,0Zm-1.71,8.2a2.76,2.76,0,1,1,2.75-2.76A2.75,2.75,0,0,1,50.35,53.11Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChuzhen);
export default __webpack_public_path__ + "static/media/chuzhen.69c02a5c.svg";
export { ForwardRef as ReactComponent };